import { MatDialogRef } from "@angular/material/dialog";
import { ModalDialog } from "../Modal/modal";

export async function WaitForModalResult(ref: MatDialogRef<ModalDialog, any>): Promise<boolean> {
    return await new Promise((resolve) => {
        ref.afterClosed()
            .subscribe(result => {
                if (result) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            });
    });
}